<template>
  <v-form @submit.prevent="submit">
    <v-text-field v-model="lcForm.name" label="Name" />
    <v-row>
      <v-col class="d-flex justify-end">
        <v-btn color="primary" type="submit">
          Speichern
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>

export default {
   name: 'BundleItemGroupForm',
   props: {
      form: {
         type: Object,
         required: true
      },
      type: {
         type: String,
         required: true
      }
   },
   data: function () {
      return {
         lcForm: this.form,
      }
   },
   methods: {
      submit () {
         if (this.type === 'create') {
            this.lcForm.post(this.route('bundle.group.store'))
         }
         if (this.type === 'edit') {
            this.lcForm.patch(this.route('bundle.group.update', { group: this.form.id }))
         }
      }
   }
}
</script>

<style lang="scss" scoped>

</style>
